export const SETTING_TABLE_NAME = {
  GENERAL_SETTING: "GeneralSettings",
  ALARM_SETTINGS: "AlarmSettings",
  DEVICE_43I_SETTINGS: "DeviceSettings43i",
  ANALOG_OUTPUT_SETTINGS: "AnalogOutputSettings",
  AUTOZERO_SETTINGS: "AutoZeroSettings",
  DEVICE_60I_SETTINGS: "DeviceSettings60i",
  GAS_CYLINDER_SETTINGS: "CylinderSettings",
  PID_CONTROLLER_SETTINGS: "PIDControllerSettings",
  QAL3_SETTINGS: "QAL3Settings",
  RESPONSE_TIME_SETTINGS: "ResponseTimeSettings",
  SO2_SCRUBBER_SETTINGS: "SO2ScrubberSettings",
  STABILITY_SETTINGS: "StabilitySettings",
  ANALOG_SIGNAL_SETTINGS: "AnalogSignalSettings",
};
